 <div class="map-container">
  <div class="map-frame">
    <div id="mapInput" (click)="mapClick()"></div>
  </div>
</div>
<div class="map-left-panel" *ngIf="allowAdd">
  <span>Drag and Drop</span>
  <img src="../../../assets/marker.svg" alt="leaf">
</div>
